/**
 *
 */
class batchHandle {
    constructor($uibModal) {
        this.$uibModal = $uibModal
    }
    open() {
        return new Promise((resolve) => {

            this.$uibModal.open({
                template: getDialogTemplate(),
                backdrop: 'static',
                controller: ['$scope', '$uibModalInstance', modalCtrl],
                openedClass: 'mod-modal mod-modal-md',
            }).result.then((data) => {
                // 点击确定才更新自定义配置
                resolve(data)
            })
        })
    }
}

function getDialogTemplate() {
    return `
    <div class="modal-header">
    <h3 class="modal-title">操作提醒</h3> 
    <div class="modal-cancel close" ng-click="cancel()"><i class="icon iconfont icon-shanchu3"></i></div>
</div>

<div class="modal-body form-horizontal origin-account-modal">
<p>确认提交发票？</p>
<p>自定义批量提交（数量）</p>
<div class="clearfix mod-batch-body">
    <div class="f-fl">
        <input type="text" class="form-control mod-batch-ipt" placeholder="起始数" ng-model="startRow " ng-blur="check()" ng-focus="showTips=false;">
    </div>
    <div class="f-fl mod-link-ipt"></div>
    <div class="f-fl">
        <input type="text" class="form-control mod-batch-ipt" placeholder="末位数" ng-model="endRow " ng-blur="check(1)" ng-focus="showTips=false;">
    </div>
    <div class="mod-batch-tips require" ng-if="showTips">填写1~2000的整数</div> 
</div>
</div>
<div class="modal-footer">
    <button class="btn btn-default btn-md" type="button" ng-click="cancel()">取消</button>
    <button class="btn btn-primary btn-md" type="button" ng-click="ok()">确定</button>
</div>

    `
}

function modalCtrl($scope, $uibModalInstance) {
    $scope.check = function (v) {
        const reg = /^[0-9]*$/g
        if (v && $scope.endRow ) {
            if (!reg.test($scope.endRow ) || $scope.endRow  > 2000 || $scope.endRow  < 1) {
                $scope.endRow  = ''
                $scope.showTips = true
            }
            if ($scope.startRow  && +$scope.startRow  > +$scope.endRow ) $scope.endRow  = ''
        } else if ($scope.startRow ) {
            if (!reg.test($scope.startRow ) || $scope.startRow  < 1 || $scope.startRow  > 2000) {
                $scope.startRow  = ''
                $scope.showTips = true
            }
            if ($scope.endRow  && +$scope.startRow  > +$scope.endRow ) $scope.startRow  = ''
        }
    }


    // 关闭
    $scope.cancel = function cancel() {
        $uibModalInstance.dismiss('cancel')
    }
    // 确定
    $scope.ok = function ok() {
        $uibModalInstance.close({
            startRow : $scope.startRow ,
            endRow : $scope.endRow 
        })
    }
}


batchHandle.$inject = ['$uibModal']
export default batchHandle


// WEBPACK FOOTER //
// ./src/common/services/batchHandle.js